import Vue from 'vue'
import Vuex from 'vuex'
import passport from './passport'
import job from './job'
import resume from './resume'
import center from './center'
import ajax from '../assets/js/ajax'
import cookie from '../assets/js/cookie'
import defaultImg from '../assets/images/default.jpg'
import {AUTH_KEY} from '../assets/js/config'
Vue.use(Vuex)
const state = {
  easteatAuth: cookie.get(AUTH_KEY),
  indexData: null,
  defaultImg
}
const actions = {
  indexPageJson (ctx) {
    return ajax.get('/zhaopin/b/company/index.json')
      .then(data => ctx.commit('indexPageJson', data))
  },
  imageCut (ctx, params) {
    return ajax.post('/file/cut.json', params)
  },
  uploadFile (ctx, params) {
    return ajax.upload('/file/upload.json', params)
  }
}
const mutations = {
  indexPageJson (state, data) {
    state.indexData = data
  }
}
export default new Vuex.Store({
  state,
  actions,
  mutations,
  modules: {
    job,
    center,
    resume,
    passport
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js